import connect from 'react-redux/es/connect/connect';

import { addCartItems, updateBooker } from '../actions/cart';
import SingleActivity from '../components/single-activity/SingleActivity';

const mapStateToProps = state => ({
    customer: state.user.customer || {},
    user: state.user.user
});

const mapDispatchToProps = dispatch => ({
    fillCart: cartItems => {
        dispatch(addCartItems(cartItems));
    },
    updateBookingGuest: guest => {
        dispatch(updateBooker(guest));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleActivity);
